import { gql } from "@apollo/client";

export const GET_LIST_RESERVATION = gql`
  query GetReservationList(
    $paginationParams: BaseCollection!
    $tripPublicationId: String
    $ownerId: String
  ) {
    QR_LIST_TRIP_RESERVATION(
      paginationParams: $paginationParams
      tripPublicationId: $tripPublicationId
      ownerId: $ownerId
    ) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        totalElements
        totalPages
        currentPage
        content {
          id
          publicationId
          status
          clients {
            firstName
            lastName
            isMainPerson
            personId
          }
          pricingDetails {
            travelPricingPerPerson {
              value
              currency
            }
            travelTotalPriceWithoutCharge {
              value
              currency
            }
            serviceFees {
              value
              currency
            }
            paimentFees {
              value
              currency
            }
            activitiesTotalPrice {
              value
              currency
            }
            optionsTotalPrice {
              value
              currency
            }
            travelTotalPrice {
              value
              currency
            }
          }
          tripDate {
            id
            startDate
            endDate
            nbNight
          }
          reservedPlaces {
            adultPlacesCount
            childPlacesCount
            babiesPlacesCount
          }
          tripPublicationResume {
            trip {
              establishment {
                id
                company {
                  legalName
                }
              }
              title
              pictures {
                isMain
                link
              }
              tripProgramDetails {
                country
              }
            }
          }
        }
      }
    }
  }
`;

export const QR_GET_TRIP_RESERVATION = gql`
  query GetReservation($tripReservationId: String!) {
    QR_GET_TRIP_RESERVATION(tripReservationId: $tripReservationId) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        id
        publicationId
        status
        clients {
          firstName
          lastName
          dateOfBirth
          travelerType
          isMainPerson
          personId
        }
        activitesPurchased {
          id
          title
          picture
          description
          isIncluded
          adultPricePerPerson {
            value
            currency
          }
          childPricePerPerson {
            value
            currency
          }
          babiesPricePerPerson {
            value
            currency
          }
        }
        optionsPurchased {
          id
          title
          picture
          description
          adultPricePerPerson {
            value
            currency
          }
          childPricePerPerson {
            value
            currency
          }
          babiesPricePerPerson {
            value
            currency
          }
        }
        pricingDetails {
          travelPricingPerPerson {
            value
            currency
          }
          travelTotalPriceWithoutCharge {
            value
            currency
          }
          serviceFees {
            value
            currency
          }
          paimentFees {
            value
            currency
          }
          activitiesTotalPrice {
            value
            currency
          }
          optionsTotalPrice {
            value
            currency
          }
          travelTotalPrice {
            value
            currency
          }
        }
        tripDate {
          id
          startDate
          endDate
          nbDays
          nbNight
          isFlightIncluded
          travelManagers {
            fullName
            email
            phoneNumber {
              indicative
              number
            }
          }
          flightItinerary {
            outboundFlight {
              isFlightWithStopover
              flights {
                description
                departureFlightCity
                departureFlightCountry
                departureFlightAirport
                departureFlightTime
                arrivalFlightCity
                arrivalFlightCountry
                arrivalFlightAirport
                arrivalFlightTime
                flightNumber
                flightBaggageInformation
                flightCompany
                flightCompanyLogo
                connectionDuration
              }
            }
            returnFlight {
              isFlightWithStopover
              flights {
                description
                departureFlightCity
                departureFlightCountry
                departureFlightAirport
                departureFlightTime
                arrivalFlightCity
                arrivalFlightCountry
                arrivalFlightAirport
                arrivalFlightTime
                flightNumber
                flightBaggageInformation
                flightCompany
                flightCompanyLogo
                connectionDuration
              }
            }
          }
          stepsDate {
            date
            stepIds
          }
        }
        reservedPlaces {
          adultPlacesCount
          childPlacesCount
          babiesPlacesCount
        }
        tripPublicationResume {
          trip {
            establishment {
              id
              company {
                legalName
              }
            }
            title
            smallDescription
            detailedDescription
            pictures {
              isMain
              link
            }
            tripProgramDetails {
              id
              picture {
                link
                isMain
              }
              city
              country
              stay
              hosting {
                name
                stars
              }
              description
              activities {
                id
                title
                picture
                description
                isIncluded
                adultPricePerPerson {
                  value
                  currency
                }
                childPricePerPerson {
                  value
                  currency
                }
                babiesPricePerPerson {
                  value
                  currency
                }
              }
              ranking {
                rank
                title
              }
              options {
                id
                title
                picture
                description
                adultPricePerPerson {
                  value
                  currency
                }
                childPricePerPerson {
                  value
                  currency
                }
                babiesPricePerPerson {
                  value
                  currency
                }
              }
            }
          }
        }
      }
    }
  }
`;
